import { z } from 'zod';
import { boundedDateRange } from './payroll.schema.js';
import { MAX_ATTENDANCE_RANGE_DAYS } from './attendance.schema.js';

/**
 * GET /corrections?employeeId=&from=&to= — ONE worker's requests over the
 * range their attendance history is showing, in EVERY status.
 *
 * The approver's other read is the pending queue, which answers "what is
 * waiting on me". The history page asks a different question about a single
 * worker — "which of these days were corrected, and how was it decided" — and
 * a queue of only the waiting rows cannot answer it: an approved day would
 * read the same as a day nobody ever asked about.
 *
 * `from`/`to` are COMPANY day keys, the same pair the days and events queries
 * on that page send (docs/time-and-dates.md), held to the same 92-day cap.
 * A file of its own because `attendance.schema.ts` is at its line budget.
 */
export const CorrectionRangeQuerySchema = z
  .object({
    employeeId: z.string().min(1),
    from: z.string().date(),
    to: z.string().date(),
  })
  .superRefine(boundedDateRange(MAX_ATTENDANCE_RANGE_DAYS));
export type CorrectionRangeQuery = z.infer<typeof CorrectionRangeQuerySchema>;
